import React, { Component } from 'react';
import { Table } from 'react-bootstrap';

import axios from '../../../services/axios-service';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import './ClientManagement.css';
import ManageClient from '../../../components/Admin/ManageClient/ManageClient';
import {checkValidity} from '../../../shared/utility';
import Button from '../../../components/UI/Button/Button';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';
import admmoreIcon from '../../../assets/images/admin-more-vertical-rec.svg';
import SearchBox from '../../../components/UI/SearchBox/SearchBox';
import searchIcon from '../../../assets/images/search-icon-aqua-blue.svg';
import Icon from '../../../components/UI/Icon/Icon';
import moment from 'moment';

/**
* @desc client Management
* @version 0.1.0
* @author Lakshmikanth V,Jamshith
*/

const initialClientDetails = {
  companyName:'',
  companyBHId:'',
  companyAddress:'',
  contactName:'',
  contactEmail:'',
  bullhornId:'',
  telephoneNo:'',
  companyType:2,
}
class ClientManagement extends Component {
  constructor() {
    super();
    this.state = {
      clients : [],
      clientDetails:{...initialClientDetails},
      errorPosition:[],
      addCompanyModal:false,
      updateCompanyModal:false,
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastId: null,
      disableAddbutton:false,
      showMoreOption:false,
      moreOptionIndex:'',
      clientSearchResults: [],
      searchParam: "",
      activeSort:"dateAdded",
      sortType: "desc"
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentWillMount(){
    this.getAllClients();
  }
  
  componentDidMount(){
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(nextProps, nextState){
    if(nextState.clients !== this.state.clients)  {
      this.setState({sortType: "desc"})
    }

  }

  componentWillUnmount(){
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside = (event) =>{
    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && event.target.id !== ("more-option-update"||"more-option-delete"||"more-option-transfer")) {
      this.setState({showMoreOption:false});
    }
  }
   /**
   * @desc Function to open Add company Modal
   * @param event
   * @return null
   */

  openMoreOption = (e,index) => {
    e.preventDefault();
    this.setState({showMoreOption:true,moreOptionIndex:index})
  }

  onHandleAddCompany(e){
    e.preventDefault();
    this.setState({addCompanyModal:true})
  }

  cancelAddCompany =(e) =>{
    e.preventDefault();
    this.setState({
      addCompanyModal:false,
      updateCompanyModal:false,
      errorPosition:[],
      clientDetails:{...initialClientDetails},
      disableAddbutton:false,
      searchParam: "",
      clientSearchResults:this.state.clients
    })
  }
 /**
  * @desc Get existing client company details
  * @param null
  * @return null
  */
  getAllClients = () => {
    axios.get("/galaxy/company").then(response => { 
      if(response.data.length > 0) {
        const clients = response.data;
        this.setState({ 
          clients : clients,
          clientSearchResults: clients,
          searchParam: ""
        }); 
      }
    })
    .catch((error) => {
      ConsoleLog('error',error);
    });
  }

  KeyPressChange = (e) => {
    const variable=this.state.clientDetails[e.target.id];
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;                    
    if ((charCode > 31 && (charCode < 47 || charCode > 57))|| (variable && variable.length>15)){
      e.preventDefault();
    }
    
    if (e.shiftKey) {
      e.preventDefault();
    } 
    
  }
  
  updateCompanyDetails = (e,company) => {
    e.preventDefault();
    const companyDetails = {...company};
    Object.keys(companyDetails).forEach((key) => {
      if (companyDetails[key] == null) {
        companyDetails[key] ="";
      }
    });
    companyDetails.userType = 2;
    this.setState({clientDetails:{...companyDetails}, updateCompanyModal:true,showMoreOption:false});
  }

  KeyPressChange = (e) => {
    ConsoleLog("value",e.target.id)
    const variable=this.state.clientDetails[e.target.id];
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;                    
    if ((charCode > 31 && (charCode < 47 || charCode > 57))||(variable && variable.length)>15){
      e.preventDefault();
    }
    
    if (e.shiftKey) {
      e.preventDefault();
    } 
    
  }

  KeyPasteChange = (e) => {
    if(!checkValidity(e.clipboardData.getData('text/plain'),'isNumeric'))  {
      e.preventDefault();
      const error = e.target.id === "companyBHId" ? "invalidCompanyBHId":e.target.id === "bullhornId"?"invalidBullhornId":"invalidTelephoneNo";
      let newErrorPosition = [...this.state.errorPosition]
      newErrorPosition=  newErrorPosition.concat(error);
      this.setState({errorPosition:newErrorPosition});
    }

  }

  clientDetailsChange = (e) => {
    const name = e.target.id;
    let clientDetails = this.state.clientDetails;
    clientDetails[name] = e.target.value;
    let newErrorPosition = [];
    if(name === "contactEmail") {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "contactEmailEmpty" && errPosition !== "contactEmailFormat" && errPosition !== "UserExists"));
    }
    else if(name === "bullhornId"){
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "BullhornIdExists" && errPosition !== "bullhornId"  && errPosition !== "invalidBullhornId"));
    }
    else if(name === "companyBHId"){
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "companyBHId" && errPosition !== "CompanyExists"  && errPosition !== "invalidCompanyBHId"));
    }
    else if(name === "telephoneNo"){
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "telephoneNo" && errPosition !== "invalidTelephoneNo"));
    }
    else {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => errPosition !== name);
    }
    this.setState({clientDetails,errorPosition:newErrorPosition});
  }

  onSubmitClientDetails = (e) => {
    this.setState({disableAddbutton:true});
    e.preventDefault();
    if(!checkValidity(this.state.clientDetails.companyBHId,'isNumeric') 
    || this.state.clientDetails.companyBHId.toString().trim() === ""
    || this.state.clientDetails.companyName.trim() === "" 
    || this.state.clientDetails.companyAddress.trim() === "" )
    {
      let errorPosition = [];
      if(this.state.clientDetails.companyName.trim() === "") {
        errorPosition = errorPosition.concat('companyName');
      }
      if(this.state.clientDetails.companyBHId.toString().trim() === "") {
        errorPosition = errorPosition.concat('companyBHId');
      }
      if(this.state.clientDetails.companyAddress.trim() === "") {
        errorPosition = errorPosition.concat('companyAddress');
      }
      this.setState({
        errorPosition: errorPosition,
        disableAddbutton:false,
        searchParam: ""
      });
    } else {
      if(this.state.clientDetails.contactName.trim() !== "" 
      || this.state.clientDetails.bullhornId.toString().trim() !== "" 
      || this.state.clientDetails.telephoneNo.trim() !== "" 
      || this.state.clientDetails.contactEmail.trim() !== "") {
      if(this.state.clientDetails.contactName.trim() !== "" 
      && this.state.clientDetails.bullhornId.toString().trim() !== "" 
      && this.state.clientDetails.contactEmail.trim() !== "" 
      && checkValidity(this.state.clientDetails.contactEmail,'isEmail')) {
        this.postClientDetails();
      } else {
        let errorPosition = [];
        if(this.state.clientDetails.contactName.trim() === "") {
          errorPosition = errorPosition.concat('contactName');
        }
        if(!checkValidity(this.state.clientDetails.bullhornId,'isNumeric') || this.state.clientDetails.bullhornId.toString().trim() === "") {
          errorPosition = errorPosition.concat('bullhornId');
        }
        if(this.state.clientDetails.contactEmail.trim() === "") {
          errorPosition = errorPosition.concat('contactEmailEmpty');
        } else if(!checkValidity(this.state.clientDetails.contactEmail,'isEmail')) {
          errorPosition = errorPosition.concat('contactEmailFormat');
        }
        
        this.setState({
          errorPosition: errorPosition,
          disableAddbutton:false,
          searchParam: ""
        });
      }
    }
    else {
      this.postClientDetails();
    }
    }
  }

  postClientDetails = () => {
    let clientDetails = {...this.state.clientDetails};
    clientDetails.bullhornId = clientDetails.bullhornId.toString();
    clientDetails.companyBHId = clientDetails.companyBHId.toString();
    if(clientDetails.companyId) {
      axios.post("/galaxy/company/" + clientDetails.companyId, JSON.stringify(clientDetails))
      .then((response)=>{ 
        //ConsoleLog("response",response.data)  
        this.updateClientDetails(response.data.message);  
      })
      .catch((error) => {
        ConsoleLog(error);
        throw error;
      });
    }
    else {
      axios.post("/galaxy/company",JSON.stringify(clientDetails))
      .then((response)=>{ 
        //ConsoleLog("response",response.data)    
        this.updateClientDetails(response.data.message); 
        })
      .catch((error) => {
        ConsoleLog(error);
        throw error;
      });
    }
  }
  updateClientDetails = (message) => {
    const toastMessage = this.state.addCompanyModal?"Client created successfully!":this.state.clientDetails.companyName +' account successfully updated';
    if(message==="success" ||message==="client created successfully"||message==="company created successfully"){
      this.setState({
        addCompanyModal:false,
        isShowToast: true,
        toastMessage: toastMessage,
        toastVariant: 'success',
        toastId: "tid" + (new Date()).getTime(),
        clientDetails:{...initialClientDetails},
        errorPosition:[],
        disableAddbutton:false,
        updateCompanyModal:false,
        searchParam: ""
      });
      this.getAllClients(); 
    }
    else if(message=="User already exists") {
      let errorPosition = [];
      errorPosition = errorPosition.concat('UserExists');
      this.setState({errorPosition,disableAddbutton:false});
    }
    else if(message=="Company already exists") {
      let errorPosition = [];
      errorPosition = errorPosition.concat('CompanyExists');
      this.setState({errorPosition,disableAddbutton:false});
    }
    else if(message=="User Bullhorn ID already exists") {
      let errorPosition = [];
      errorPosition = errorPosition.concat('BullhornIdExists');
      this.setState({errorPosition,disableAddbutton:false});
    }
  }

  clientSearchHandler = (e) => {
    const searchParam = e.target.value;
    this.setState({ searchParam: searchParam });
    const clientsList = [...this.state.clients];
    const clients = clientsList.filter(client => (
      client.companyName.toLowerCase().includes(searchParam.toLowerCase()) || 
      client.companyBHId.toString().includes(searchParam.toLowerCase()) 
    ));
    this.setState({ clientSearchResults: clients });
  }

  sortClient = (sortField) => {
    const sortType = (sortField === this.state.activeSort) ? ((this.state.sortType === 'asc') ? 'desc' : 'asc') : this.state.sortType;
    
    const clients = [...this.state.clientSearchResults];
    let sortedClients=[];
    if(sortField==="dateAdded") {
      sortedClients = clients.sort((a, b) => {
        const [ firstDate, secondDate ] = (sortType === 'desc') ? [b, a] : [a, b];
        return new Date(firstDate.companyCreatedDate).getTime() - new Date(secondDate.companyCreatedDate).getTime();;
       });
    }
    else if(sortField==="cname") {      
      sortedClients = clients.sort((a, b) => {
        const [ nameA, nameB ] = (sortType === 'desc') ? [b.companyName.toLowerCase(), a.companyName.toLowerCase()] : [a.companyName.toLowerCase(), b.companyName.toLowerCase()];
        if (nameA < nameB) return -1 
        if (nameA > nameB) return 1
        return 0
       });
    }
    else if(sortField==="contact-name") {
      sortedClients = clients.sort((a, b) => {
        const [ nameA, nameB ] = (sortType === 'desc') ? [b.contactName?b.contactName.toLowerCase():"",a.contactName? a.contactName.toLowerCase():""] : [a.contactName? a.contactName.toLowerCase():"", b.contactName?b.contactName.toLowerCase():""];
        if (nameA < nameB) return -1 
        if (nameA > nameB) return 1
        return 0
       });
    }
     
    this.setState({ clientSearchResults: sortedClients,activeSort:sortField, sortType: sortType});
    
  }

  render() {
    const clients = [...this.state.clientSearchResults];
    return (
      <React.Fragment>
        <Table striped condensed hover className="admin-company-list-container-tbl">
          <thead className="admin-company-list-container-head">
          <tr>
            <th colspan="9" align="right" className="add-company">
            <SearchBox  
              icon={searchIcon}
              isBorder={false}
              iconPosition={'right'}
              iconInside={false}
              className={(this.state.searchParam.length>0) ? "search-active" : ""}
              value={this.state.searchParam}
              onChange={this.clientSearchHandler.bind(this)}
              placeholder="Company name or BH ID"
            />
            <Button className="admin-add-company-btn"onClick={(e)=>this.onHandleAddCompany(e)}>+ Add a Client</Button></th>
          </tr>
             <tr className="admin-company-list-container-tr-head">
              <th className="dateadded" width="100">Date Added
                <Icon 
                  icon={(this.state.activeSort==="dateAdded")?((this.state.sortType==="desc")?"down-arrow":"up-arrow-sort"):"down-arrow-disabled"} 
                  className="rec-down-arrow" 
                  onClick={()=>this.sortClient("dateAdded")}>
                </Icon>
              </th>
              <th className="cname" width="120">Company Name
                <Icon 
                  icon={(this.state.activeSort==="cname")?((this.state.sortType==="desc")?"down-arrow":"up-arrow-sort"):"down-arrow-disabled"} 
                  className="rec-down-arrow" 
                  onClick={()=>this.sortClient("cname")}>
                </Icon>
              </th>
              <th className="cbhid">Company Bullhorn ID</th>
              <th className="caddress">Company Address</th>
              <th className="contact-name" width="170">Primary Contact Name
                <Icon 
                  icon={(this.state.activeSort==="contact-name")?((this.state.sortType==="desc")?"down-arrow":"up-arrow-sort"):"down-arrow-disabled"} 
                  className="rec-down-arrow" 
                  onClick={()=>this.sortClient("contact-name")}>
                </Icon>
              </th>
              <th className="contact-bhid">Primary Contact Bullhorn ID</th>
              <th className="contact-email">Primary Contact Email</th>
              <th className="contact-telephone-no">Primary Contact Phone No.</th>
              <th></th>
              {/* <th className="action">&nbsp;</th> */}
             </tr> 
          </thead>
          <tbody className="admin-company-list-container-tblbody">
            {clients.length>0?
              clients.map((company, index) => (
                <tr className="admin-company-list-container-trbody">
                  <td className="dateadded">{moment(company.companyCreatedDate).format('DD/MM/YYYY')}</td>
                  <td className="cname">{company.companyName}</td>
                  <td className="cbhid">{company.companyBHId}</td>
                  <td className="caddress">{company.companyAddress}</td>
                  <td className="contact-name">{company.contactName}</td>
                  <td className="contact-bhid">{company.bullhornId}</td>
                  <td className="contact-email">{company.contactEmail}</td>
                  <td className="contact-telephone-no">{company.telephoneNo}</td>
                  <td className="cli-more-optionth">
                      <div className="admin-more-container" >
                        <span><img src={admmoreIcon} onClick={(e)=>this.openMoreOption(e,index)} /></span>
                        {(this.state.showMoreOption && this.state.moreOptionIndex===index)? 
                          <div className="admin-more-options" id="admin-more-options" ref={this.setWrapperRef}>
                            <div className="more-option-update" id="more-option-update" onClick={(e)=>this.updateCompanyDetails(e,company)}>Update
                            </div>
                            {/*<div className="more-option-delete">Delete</div>
                            <div className="more-option-transfer">Transfer</div> */}
                          </div>
                        :""}
                         
                      </div>
                    </td>
                </tr>
            )):
            <React.Fragment>
            <tr className="admin-company-list-container-trbody">
              <td colspan="9" className="noresults">{"No matching users were found"}</td>
            </tr>
            <tr className="admin-company-list-container-trbody"> </tr>
          </React.Fragment>}         
          </tbody>
        </Table>
        <ManageClient
          clientDetails={this.state.clientDetails}
          handleClientDetailsChange={this.clientDetailsChange}
          handleKeyPressChange={this.KeyPressChange}
          handlePasteChange={this.KeyPasteChange}
          submitClientDetails ={this.onSubmitClientDetails}
          showAddCompanymodal={this.state.addCompanyModal}
          showUpdateCompanyModal={this.state.updateCompanyModal}
          handleCancelAddCompany={this.cancelAddCompany}
          errorPosition={this.state.errorPosition}
          disableAddbutton={this.state.disableAddbutton}
        />
        {this.state.isShowToast?
          <ToastNotification 
            isShowToast={this.state.isShowToast} 
            message={this.state.toastMessage} 
            variant={this.state.toastVariant} 
            autoClose={this.state.toastAutoClose}
            onClose={this.handleCloseToastNotification}
            toastId= {this.state.toastId} 
          />:""}
      </React.Fragment>
    )
  }
}

export default ClientManagement;



// WEBPACK FOOTER //
// ./src/container/Admin/ClientManagement/ClientManagement.js